import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { SessionStorage } from './CookieStorage'
import { Environment } from 'enviroment/AppSettings'
import { STORAGEKEYS } from 'enviroment/Keys'
import { HubMethodsModel } from 'models/HubMethodsModel'

 export class HubClient {
   private readonly _connection: HubConnection;
   private readonly _apiUrl: string;
   private readonly _sessionStorage : SessionStorage;
 
   public static readonly hubMethods: HubMethodsModel = {
     bmVerifyUrl: 'bm_verify_url',
     applicationRejected: 'rejected',
     documentsRedy: 'documents_ready', 
     sessionTimeout: 'session_timeout',
     calculateOffer: 'calculate_offer',
     mObywatelIdentification: 'mobywatel_identification',
     mObywatelVerification: 'mobywatel_verification'
   };
 
   constructor(hubName: string) {
     this._apiUrl = `${Environment.apiUrl}${hubName}`;
     this._sessionStorage = new SessionStorage();
     this._connection = this.createConnection(this._apiUrl);
   }

   private createConnection(apiUrl: string): HubConnection {
     const builder = this.configureConnection(apiUrl);
     const connection = builder.build();
     return connection;
   }

   private configureConnection(apiUrl: string): HubConnectionBuilder {
       const builder = new HubConnectionBuilder()
         .withUrl(apiUrl, { accessTokenFactory: () => this._sessionStorage.get(STORAGEKEYS.ACCESS_TOKEN)})
         .withAutomaticReconnect();
       return builder;
   }
 
   public subscribe<T>(methodName : string,callback: (data: T) => void){
       this._connection.on(methodName, callback);
   }
 
   public stop(){
     this._connection.stop();
   }

   public start(){
     try{
       this._connection.start();
     }
     catch(err){
       setTimeout(this.start, 5000);
     }
   }
 }
 